// extracted by mini-css-extract-plugin
export default {"page":"KhVdjt","previous":"acbUIp","first":"IeY3vx","next":"gwgQCb","last":"lfi41p","active":"sI4Nnn","large":"wR7lgz","arrow":"RcfyI6","inner":"ixAZGX"};